<template>
  <div class="px-3 md:px-0">
    <h1 class="text-lg font-bold">Lecciones</h1>
    <div class="text-neutral-700 mt-5 space-y-4">
      <p>
        En las lecciones encontrarás una variedad de ejercicios que abarcan una
        amplia gama de conceptos y habilidades fundamentales. Estos pueden
        incluir, pero no se limitan a, los siguientes: Geometría analítica,
        Transformaciones geométricas, construcciones geométricas.
      </p>
      <p>
        El objetivo es ofrecerte una comprensión completa y profunda de la
        geometría, desde sus fundamentos hasta sus aplicaciones en la vida real
        y otros campos de la matemática.
      </p>
    </div>

    <div class="mt-5 space-y-6">
      <div v-for="section in sectionsWithItems" :key="section.id != null ? section.id : 'default'" class="space-y-2">
        <h2 v-if="section.title" class="text-base font-semibold text-gray-800">{{ section.title }}</h2>
        <MobList :items="section.items" />
      </div>
    </div>
  </div>
</template>

<script>
import { MobList } from "@/views/V2/components";
import { getStudentStatusLessons, getStudentStatusLessonsBySection } from "@/services/lessons.service";

function lessonToItem(element, courseId, isEnrolled) {
  let currentState = '';
  let link = `/course/${courseId}/lessons/${element.id}`;
  if (!isEnrolled) {
    currentState = 'disabled';
    link = `/course/${courseId}/lessons`;
  } else if (element.finished) {
    currentState = 'completed';
  }
  return {
    label: element.title,
    icon: "iconamoon:eye-light",
    link,
    state: currentState,
    isPremium: element.isPremium,
  };
}

export default {
  name: "LessonIntro",
  components: {
    MobList,
  },
  data() {
    return {
      sectionsWithItems: [],
    };
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
  },
  watch: {
    course: {
      immediate: true,
      async handler(newCourse) {
        if (newCourse?.id == null) return;
        const courseId = this.$route.params.id;
        if (!courseId) return;
        this.sectionsWithItems = [];
        const isEnrolled = !!this.course?.enrolled;
        const sections = await getStudentStatusLessonsBySection(courseId);
        if (sections && sections.length > 0) {
          this.sectionsWithItems = sections.map((sec) => ({
            id: sec.id,
            title: sec.title,
            items: (sec.lessons || []).map((el) => lessonToItem(el, courseId, isEnrolled)),
          }));
          return;
        }
        const lessons = await getStudentStatusLessons(courseId);
        if (lessons && lessons.length > 0) {
          this.sectionsWithItems = [{
            id: null,
            title: 'Contenido',
            items: lessons.map((el) => lessonToItem(el, courseId, isEnrolled)),
          }];
        }
      },
    },
  },
  methods: {
    enrollToLessonAndGo(lessonId) {
      this.$router.push(`/course/${this.$route.params.id}/lessons/${lessonId}`);
    },
  },
};
</script>
